import {UserActionTypes} from "../Actions/actionTypes";

const initialState = {
    // -----------AUTH PARAPM---------
    user: {},
    isAuthenticated: false,
    loadingAuth:false,
    // ----------FOR THE REST---------
    users: [],
    currentUser: {},
    loading: false,
    error: null,
    first_login: false,
    requires_policy_acceptance: false,
    has_previous_policy_acceptance: false,
    policy_acceptance_reason: null,
    terms_version: null,
    privacy_version: null,
    terms_url: null,
    privacy_url: null,
    disclaimer_version: null,
    disclaimer_text_hash: null,
    policy_acceptance_text: null,
    disclaimer_text: null,
    policy_accepted_at: null,
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        // -----------------------------------------FOR AUTH-------------------------------------
        case UserActionTypes.SET_FIRST_LOGIN:
            return {
                ...state,
                first_login: action.payload,
            };

        case UserActionTypes.SET_POLICY_ACCEPTANCE:
            return {
                ...state,
                requires_policy_acceptance: Boolean(action.payload?.requires_policy_acceptance),
                has_previous_policy_acceptance: Boolean(action.payload?.has_previous_policy_acceptance),
                policy_acceptance_reason: action.payload?.policy_acceptance_reason ?? (
                    action.payload?.requires_policy_acceptance === false ? "current" : state.policy_acceptance_reason
                ),
                terms_version: action.payload?.terms_version ?? state.terms_version,
                privacy_version: action.payload?.privacy_version ?? state.privacy_version,
                terms_url: action.payload?.terms_url ?? state.terms_url,
                privacy_url: action.payload?.privacy_url ?? state.privacy_url,
                disclaimer_version: action.payload?.disclaimer_version ?? state.disclaimer_version,
                disclaimer_text_hash: action.payload?.disclaimer_text_hash ?? state.disclaimer_text_hash,
                policy_acceptance_text: action.payload?.policy_acceptance_text ?? state.policy_acceptance_text,
                disclaimer_text: action.payload?.disclaimer_text ?? state.disclaimer_text,
                policy_accepted_at: action.payload?.policy_accepted_at ?? state.policy_accepted_at,
                currentUser: {
                    ...state.currentUser,
                    ...action.payload,
                },
                user: {
                    ...state.user,
                    ...action.payload,
                },
                error: null,
            };

      case UserActionTypes.SET_AUTH:
            return {
                ...state,
                isAuthenticated: action.payload,
                error: null
            };

        case UserActionTypes.SET_USER:
            return {
                ...state,
                user: action.payload,
                error: null
            };
         case UserActionTypes.SET_LOADING_AUTH:
            return {
                ...state,
                loadingAuth: action.payload,
                error: null
            };
        // -----------------------------------------FOR THE REST---------------------------------

        case UserActionTypes.SET_CURRENT_USER:
            return {
                ...state,
                currentUser: action.payload,
                first_login: action.payload?.first_login ?? state.first_login,
                requires_policy_acceptance: Boolean(action.payload?.requires_policy_acceptance),
                has_previous_policy_acceptance: Boolean(action.payload?.has_previous_policy_acceptance),
                policy_acceptance_reason: action.payload?.policy_acceptance_reason ?? (
                    action.payload?.requires_policy_acceptance === false ? "current" : state.policy_acceptance_reason
                ),
                terms_version: action.payload?.terms_version ?? state.terms_version,
                privacy_version: action.payload?.privacy_version ?? state.privacy_version,
                terms_url: action.payload?.terms_url ?? state.terms_url,
                privacy_url: action.payload?.privacy_url ?? state.privacy_url,
                disclaimer_version: action.payload?.disclaimer_version ?? state.disclaimer_version,
                disclaimer_text_hash: action.payload?.disclaimer_text_hash ?? state.disclaimer_text_hash,
                policy_acceptance_text: action.payload?.policy_acceptance_text ?? state.policy_acceptance_text,
                disclaimer_text: action.payload?.disclaimer_text ?? state.disclaimer_text,
                policy_accepted_at: action.payload?.policy_accepted_at ?? state.policy_accepted_at,
                isAuthenticated: true,
                error: null
            };

        case UserActionTypes.SET_USERS:
            return {
                ...state,
                users: action.payload,
                error: null
            };

        case UserActionTypes.ADD_ONE:
            return {
                ...state,
                users: [action.payload, ...state.users], // Ajoute au début
                error: null
            };

        case UserActionTypes.UPDATE_ONE:
            return {
                ...state,
                users: state.users.map(user =>
                    user.id === action.payload.id ? { ...user, ...action.payload } : user
                ),
                error: null
            };

        case UserActionTypes.DELETE_ONE:
            return {
                ...state,
                users: state.users.filter(user => user.id !== action.payload),
                // Déconnecte si l'utilisateur supprimé est le currentUser
                currentUser: state.currentUser.id === action.payload
                    ? {}
                    : state.currentUser,
                isAuthenticated: state.currentUser.id === action.payload
                    ? false
                    : state.isAuthenticated,
                error: null
            };

        case UserActionTypes.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case UserActionTypes.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        default:
            return state;
    }
};
